export default from './FilersCases';


// WEBPACK FOOTER //
// ./src/components/case/filers/index.js